
const BraveMeasureTextError = () => {
  return (
    <div data-testid="brave-measure-text-error">

    </div>
  );
};

export default BraveMeasureTextError;
